/** ApiService throws plain `{ detail, status_code }`, not Error — surface server text. */
export function printErrorMessage(err: unknown, fallback = 'Failed to load the print form'): string {
  if (err && typeof err === 'object') {
    const o = err as { detail?: unknown; message?: unknown; response?: { data?: { detail?: unknown } } }
    const detail = o.detail ?? o.response?.data?.detail ?? o.message
    if (typeof detail === 'string' && detail.trim()) return detail
  }
  if (err instanceof Error && err.message) return err.message
  return fallback
}
